
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Habitaciones from "../pages/habitaciones/page";
import Carpas from "../pages/carpas/page";
import Hamacas from "../pages/hamacas/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/habitaciones",
    element: <Habitaciones />,
  },
  {
    path: "/carpas",
    element: <Carpas />,
  },
  {
    path: "/hamacas",
    element: <Hamacas />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
